module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p36"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rp36"
    }
  }, [_vm._v("HERBED BROCCOLI-CAULIFLOWER BISQUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("This healthful soup is so delicious, you’ll want to make enough for the freezer!")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("6 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 medium stalks broccoli")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ small head cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 cup thinly sliced green onions")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 teaspoons margarine or butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 tablespoon flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("3 cups Chicken Stock (see "), _c('a', {
    attrs: {
      "href": "#/Chapter012#p2"
    }
  }, [_vm._v("p. 2")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1½ cups coarsely chopped peeled potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 tablespoon dried basil leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1½ cups 2% reduced-fat milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Cut enough broccoli and cauliflower into florets to make ¾ cup each; reserve. Coarsely chop remaining broccoli and cauliflower. Sauté green onions in margarine in large saucepan until tender, about 4 minutes. Stir in flour; cook 1 minute. Stir in stock, chopped vegetables, and basil; heat to boiling. Reduce heat and simmer, uncovered, until vegetables are tender, about 10 minutes. Process soup in food processor or blender until smooth; return to saucepan. Add milk and reserved vegetable florets. Heat to boiling; reduce heat and simmer until florets are crisp-tender, about 5 minutes. Season to taste with salt and pepper.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 121")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 19")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 7")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 18.6")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 2.7")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 4.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 230")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 1.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 1.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.5")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c596af58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0218.vue
// module id = 189
// module chunks = 0